module.exports = __webpack_public_path__ + "media/home/Brush_Teal-9dac740b.png";